// Frowned upon, but add properties to enable features by default
//
// Please consider using !$feature('disableX') and leaving this blank instead

export default {
}
